import { Disclosure, Menu, Transition } from '@headlessui/react';
import { Avatar, Badge, Button, Popover, Spin, Table, Tooltip } from 'antd';
// import moment from 'moment';
import package_classNames from 'classnames';
import moment from 'jalali-moment';
import React, { Fragment, lazy, useContext, useEffect, useState } from 'react';
import { HiBellAlert } from 'react-icons/hi2';
import { TfiClose } from 'react-icons/tfi';
import { TiThMenu } from 'react-icons/ti';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { baseRoot } from '../../api/Apis';
import { getSmsPanel, handleCloseEmergencyAlarms } from '../../api/Services';
import Logo from '../../assets/image/Farscada-LogoSHape.png';
import LogoFarscada from '../../assets/image/minilogo.png';
import { TextCatContext } from '../../context/contextCategory/TextCatCotext';
import { TextContext } from '../../context/TextCotext';
import { useInformationData } from '../../hooks/useInformationData';
import { signOut } from '../../redux/action/Auth';
import {
  KEY_ALARMS,
  KEY_KANBANBOARD,
  KEY_SCADA,
  KEY_TRENDS,
  navbar,
} from '../../utils/constants';
import SummaryModal from '../modal/SummaryModal';
import UpdatePasswordModal from '../modal/UpdatePasswordModal';
import { getEnvs } from '../../utils/environments';
import useCalendar from '../../hooks/useCalendar';
const KanbanBoard = lazy(() => import('../../pages/kanbanBoard'));

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Navbar() {
  const { information, loading } = useInformationData();
  const {
    handleChangeMood,
    socketAlarm,
    showDatePicker,
    setShowDatePicker,
    handleAlarmList,
    alarmCount: socketCount,
    playAlarm,
    setPlayAlarm,
    alarmHappenSocket,
    isErrorModalVisible,
    setIsErrorModalVisible,
  } = useContext(TextContext);
  // ***************************
  const {
    handleGetSettingData,
    isModalVisible,
    setIsModalVisible,
    navbarArray,
    setNavbarArray,
    alarmSocket,
    setAlarmSocket,
    closeAlarm,
    setCloseAlarm,
    setAlarmHappenSocket,
    setSocketCount,
  } = useContext(TextCatContext);

  useEffect(() => {
    handleShowNavbar();
    handleAlarmList('ALL');
    handleGetSettingData();
  }, []);

  useEffect(() => {
    if (isModalVisible == false && isErrorModalVisible == false) {
      setShowDatePicker(true);
    }
  }, [isModalVisible, isErrorModalVisible]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logoutAction = () => {
    dispatch(signOut());
    navigate('/auth/login');
  };

  function makeOptionalScadaItems() {
    const envs = getEnvs() || {};
    const items = [];
    if (String(envs.REACT_APP_SCADA_FEATURE) === 'true') {
      const DiagramComp = lazy(() => import('../../pages/scada/Scada'));
      items.push({
        tag: <DiagramComp />,
        name: KEY_SCADA,
        href: '/scada',
        current: false,
        isNavbar: true,
      });
    }
    if (String(envs.REACT_APP_KUHPAYE_SCADA_FEATURE) === 'true') {
      const DiagramComp = lazy(() => import('../../pages/scada/Kuhpaye/KuhpayeScada'));
      items.push({
        tag: <DiagramComp />,
        name: KEY_SCADA,
        href: '/scada-kuhpaye',
        current: false,
        isNavbar: true,
      });
    }
    if (String(envs.REACT_APP_SIALK_SCADA_FEATURE) === 'true') {
      const SialkComp = lazy(() =>
        import('../../pages/scada/Sialk/SialkScada'),
      );
      items.push({
        tag: <SialkComp />,
        name: KEY_SCADA,
        href: '/scada-sialk',
        current: false,
        isNavbar: true,
      });
    }
    if (String(envs.REACT_APP_KAVIRSUZAN_SCADA_FEATURE) === 'true') {
      const KavirSuzanScada = lazy(() =>
        import('../../pages/scada/TwoColumnMainScada/TwoColumnScada'),
      );
      items.push({
        tag: (
          <KavirSuzanScada
            Meter1ID={63}
            Meter2ID={64}
            Relay1ID={135}
            Relay2ID={136}
            Trans1ID={107}
            Trans2ID={108}
            Meter1Params={['ACPL1', 'ACPL2', 'ACPL3', 'APT', 'ARPT']}
            Meter2Params={['ACPL1', 'ACPL2', 'ACPL3', 'APT', 'ARPT']}
            Relay1Params={['ACPL1', 'ACPL2', 'ACPL3', 'CT', 'GF']}
            Relay2Params={['ACPL1', 'ACPL2', 'ACPL3', 'CT', 'GF']}
            Trans1Params={[
              'BA-1',
              'BT',
              'DT',
              'OLA',
              'OLT',
              'PR',
              'TA',
              'TT',
              'WT',
              'WTA',
            ]}
            Trans2Params={[
              'BA-1',
              'BT',
              'DT',
              'OLA',
              'OLT',
              'PR',
              'TA',
              'TT',
              'WT',
              'WTA',
            ]}
            RTU_PLC1ID={105}
            RTU_PLC2ID={106}
            OtherRTU_PLCID={74}
            CB1Name={'CB-Cell-1'}
            CB2Name={'CB-Cell-2'}
            CB3Name={'CB-Cell-3'}
            Earth1Name={'ES-Cell-1'}
            Earth2Name={'ES-Cell-2'}
            Earth3Name={'ES-Cell-3'}
            TransKeys={[
              'BUCHHOLTZ',
              'WINDING TEMPERATURE',
              'OIL LEVEL',
              'THERMOMETER',
              'PRESSURE RELIEF',
              'DOOR',
            ]}
            RelayTable1Header={'KSNM-RELAY-1'}
            RelayTable2Header={'KSNM-RELAY-2'}
            TransTable1Header={'LV1-Transformer'}
            TransTable2Header={'LV2-Transformer'}
            MeterTable1Header={'KSNM-LV METER1'}
            MeterTable2Header={'KSNM-LV METER2'}
          />
        ),
        name: KEY_SCADA,
        href: '/scada-KavirSuzan',
        current: false,
        isNavbar: true,
      });
    }
    if (String(envs.REACT_APP_DERAKHSHANPART_SCADA_FEATURE) === 'true') {
      const DerakhshanPartScada = lazy(() =>
        import('../../pages/scada/TwoColumnMainScada/TwoColumnScada'),
      );
      items.push({
        tag: (
          <DerakhshanPartScada
            Meter1ID={61}
            Meter2ID={62}
            Relay1ID={71}
            Relay2ID={72}
            Trans1ID={91}
            Trans2ID={108}
            Meter1Params={['ACPL1', 'ACPL2', 'ACPL3', 'APT', 'ARPT']}
            Meter2Params={['ACPL1', 'ACPL2', 'ACPL3', 'APT', 'ARPT']}
            Relay1Params={['ACPL1', 'ACPL2', 'ACPL3', 'CT', 'GF']}
            Relay2Params={['ACPL1', 'ACPL2', 'ACPL3', 'CT', 'GF']}
            Trans1Params={[
              'BA-1',
              'BT',
              'DT',
              'OLA',
              'OLT',
              'PR',
              'TA',
              'TT',
              'WT',
              'WTA',
            ]}
            Trans2Params={[
              'BA-1',
              'BT',
              'DT',
              'OLA',
              'OLT',
              'PR',
              'TA',
              'TT',
              'WT',
              'WTA',
            ]}
            RTU_PLC1ID={87}
            RTU_PLC2ID={88}
            OtherRTU_PLCID={75}
            CB1Name={'CB-Cell-1'}
            CB2Name={'CB-Cell-2'}
            CB3Name={'CB-Cell-3'}
            Earth1Name={'ES-Cell-1'}
            Earth2Name={'ES-Cell-2'}
            Earth3Name={'ES-Cell-3'}
            TransKeys={[
              'BUCHHOLTZ',
              'WINDING TEMPERATURE',
              'OIL LEVEL',
              'THERMOMETER',
              'PRESSURE RELIEF',
              'DOOR',
            ]}
            RelayTable1Header={'KDP-RELAY1'}
            RelayTable2Header={'KDP-RELAY2'}
            TransTable1Header={'LV1-Transformer'}
            TransTable2Header={'LV2-Transformer'}
            MeterTable1Header={'KDP-LV METER1'}
            MeterTable2Header={'KDP-LV METER2'}
          />
        ),
        name: KEY_SCADA,
        href: '/scada-DerakhshanPart',
        current: false,
        isNavbar: true,
      });
    }

    return items;
  }

  const handleShowNavbar = () => {
    const user = localStorage.getItem('user_info');
    const parse = JSON.parse(user);
    const envs = getEnvs() || {};
    const optionalItems = makeOptionalScadaItems();
    const base = [...navbar];
    const afterIndex = base.findIndex((i) => i.name === KEY_TRENDS);
    const insertPos = afterIndex >= 0 ? afterIndex + 1 : base.length;
    base.splice(insertPos, 0, ...optionalItems);

    let finalNavbar = base;
    if (parse?.role !== 'ADMIN') {
      const access = parse?.access;
      const accessArr = access?.map((str) => str.replace(/_/g, ' '));
      finalNavbar = base.filter((nav) => accessArr?.includes(nav.name));
    }

    if (String(envs.REACT_APP_MODE) !== 'production') {
      finalNavbar.push({
        tag: <KanbanBoard />,
        name: KEY_KANBANBOARD,
        href: '/kanban-board',
        current: false,
        isNavbar: true,
      });
    }

    setNavbarArray(finalNavbar);
  };

  const router = useLocation();

  const [smsAmount, setSmsAmount] = useState(0);
  const [smsLoading, setSmsLoading] = useState(false);

  const handleGetPanel = async () => {
    setSmsLoading(true);
    try {
      const { data } = await getSmsPanel();
      const covertToRial = data.result.remaincredit
        ? Math.floor(data.result.remaincredit / 10)
        : 'not defined';
      setSmsAmount(covertToRial);
      setSmsLoading(false);
    } catch (error) {
      setSmsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetPanel();
  }, []);
  return (
    <Disclosure as="nav" className="bg-white fixed w-full top-0 z-50">
      {({ open }) => (
        <>
          <div className="mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex h-16 items-center justify-between">
              <div className="absolute inset-y-0 left-0 flex items-center lg:hidden">
                <MobileMenuButton
                  open={open}
                  setIsModalVisible={setIsModalVisible}
                />
              </div>
              <div className="flex flex-1 items-center justify-center lg:justify-start ">
                {/* Farescada Icon */}
                <Link to="/" className="flex flex-shrink-0 items-center">
                  <img src={Logo} className="h-10" />
                </Link>

                <NavbarLinks
                  navbarArray={navbarArray}
                  router={router}
                  setIsModalVisible={setIsModalVisible}
                  socketCount={socketCount}
                />
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center sm:static sm:inset-auto sm:ml-6 sm:pr-0 ">
                {/* <MobileNotificationsBadge
                  socketCount={socketCount}
                  setIsModalVisible={setIsModalVisible}
                  /> */}
                <Tooltip
                  placement="bottom"
                  title="If you need to increase your SMS panel credit, contact support. tel: 023-33605070"
                >
                  <div
                    className={package_classNames(
                      'text-xs hidden md:flex items-center gap-2 shadow-md h-10  px-2 rounded-lg cursor-help',
                      {
                        'bg-red-100': smsAmount <= 10000,
                        'bg-gray-50': smsAmount > 10000,
                      },
                    )}
                  >
                    <span className="text-gray-700">SMS panel amount:</span>
                    <div
                      className={package_classNames(
                        'font-bold tracking-wide flex items-center gap-1',
                        {
                          'text-red-600': smsAmount <= 10000,
                          'text-gray-800': smsAmount > 10000,
                        },
                      )}
                    >
                      {smsLoading ? (
                        <Spin size="small" />
                      ) : (
                        smsAmount.toLocaleString()
                      )}
                      <span className="text-[10px] font-bold text-gray-600">
                        {smsAmount !== 'not defined' ? 'T' : null}
                      </span>
                    </div>
                  </div>
                </Tooltip>
                <UserMenu
                  loading={loading}
                  InfoData={information}
                  baseRoot={baseRoot}
                  logoutAction={logoutAction}
                  setIserrorModalVisible={setIsErrorModalVisible}
                  alarmSocket={alarmSocket}
                  playAlarm={playAlarm}
                  setSocketCount={setSocketCount}
                  setAlarmSocket={setAlarmSocket}
                  setPlayAlarm={setPlayAlarm}
                  navbarArray={navbarArray}
                />
              </div>
            </div>
          </div>
          <MobileNavbarDisclosure navbarArray={navbarArray} router={router} />
          {/* <ShowAlarm
            isModalVisible={isModalVisible}
            setIsModalVisible={setIsModalVisible}
            alarmSocket={alarmSocket}
            playAlarm={playAlarm}
            setSocketCount={setSocketCount}
            socketCount={socketCount}
            setAlarmSocket={setAlarmSocket}
          /> */}
          <ShowSoundAlarm
            isModalVisible={isErrorModalVisible}
            setIsModalVisible={setIsErrorModalVisible}
            alarmSocket={alarmHappenSocket}
            playAlarm={playAlarm}
            setPlayAlarm={setPlayAlarm}
            setAlarmSocket={setAlarmHappenSocket}
            setCloseAlarm={setCloseAlarm}
          />
        </>
      )}
    </Disclosure>
  );
}

const MobileMenuButton = ({ open, setIsModalVisible }) => (
  <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
    <span className="sr-only">Open main menu</span>
    {open ? (
      <TfiClose className="block text-gray-700 h-6 w-6" aria-hidden="true" />
    ) : (
      <TiThMenu className="block text-gray-700 h-6 w-6" aria-hidden="true" />
    )}
  </Disclosure.Button>
);

const NavbarLinks = ({
  navbarArray,
  router,
  setIsModalVisible,
  socketCount,
}) => (
  <div className="hidden sm:ml-6 lg:block">
    <div className="flex space-x-4">
      {navbarArray
        ?.filter((nav) => nav.isNavbar)
        .map((item) => (
          <NavLinkItem
            key={item.name}
            item={item}
            router={router}
            setIsModalVisible={setIsModalVisible}
            socketCount={socketCount}
          />
        ))}
      {/* <NotificationsButton
        setIsModalVisible={setIsModalVisible}
        socketCount={socketCount}
      /> */}
    </div>
  </div>
);

const NavLinkItem = ({ item, router, setIsModalVisible, socketCount }) => {
  const activeStyle = {
    color: '#5c37f0',
  };

  return (
    <>
      <NavLink
        to={item.href}
        className={classNames(
          'px-2 py-2 rounded-md text-gray-800 hover:text-indigo-600 text-sm font-medium flex gap-1',
        )}
        style={({ isActive }) => (isActive ? activeStyle : undefined)}
        aria-current={item.current ? 'page' : undefined}
      >
        {item.name}
        {item.name == KEY_ALARMS && (
          <Badge count={+socketCount} offset={[-5, -10]} />
        )}
      </NavLink>
    </>
  );
};

const NotificationsButton = ({ setIsModalVisible, socketCount }) => (
  <div
    className={classNames(
      'px-3 mt-2 rounded-md text-[#fab209] hover:text-indigo-600 text-sm font-medium cursor-pointer',
    )}
    onClick={() => setIsModalVisible(true)}
  >
    <Badge count={socketCount} showZero>
      <HiBellAlert className="text-[#fab209] hover:text-indigo-600" size={25} />
    </Badge>
  </div>
);

const MobileNotificationsBadge = ({ socketCount, setIsModalVisible }) => (
  <Badge
    count={socketCount}
    showZero
    className="mt-3 mr-2 lg:hidden"
    onClick={() => setIsModalVisible(true)}
  >
    <HiBellAlert className="text-[#fab209] hover:text-indigo-600" size={32} />
  </Badge>
);

const UserMenu = ({
  loading,
  InfoData,
  baseRoot,
  logoutAction,
  setIserrorModalVisible,
  alarmSocket,
  playAlarm,
  setSocketCount,
  setAlarmSocket,
  setPlayAlarm,
  navbarArray,
}) => (
  <Menu as="div" className="relative ml-3">
    <Menu.Button className="flex border border-2 p-0.5 rounded-full text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
      <span className="sr-only">Open user menu</span>
      {loading ? (
        <Spin size="small" />
      ) : (
        <Avatar
          size={40}
          src={
            InfoData?.image
              ? `${baseRoot}/api/uploads/${InfoData?.image}`
              : LogoFarscada
          }
        />
      )}
    </Menu.Button>
    <UserMenuItems
      logoutAction={logoutAction}
      setIserrorModalVisible={setIserrorModalVisible}
      navbarArray={navbarArray}
    />
  </Menu>
);

const UserMenuItems = ({
  logoutAction,
  setIserrorModalVisible,
  navbarArray,
}) => {
  const [profileState, setProfileState] = useState({
    loading: false,
    isModalVisible: false,
  });
  const userRole = JSON.parse(localStorage.getItem('user_info'))?.role;
  // const [userRole, setUserRole] = useState(
  //   JSON.parse(localStorage.getItem('user_info')).role || '',
  // );

  // useEffect(() => {
  //   const handleStorageChange = () => {
  //     const updatedRole =
  //       JSON.parse(localStorage.getItem('user_info'))?.role || '';
  //     setUserRole(updatedRole);
  //   };

  //   window.addEventListener('storage', handleStorageChange);

  //   return () => {
  //     window.removeEventListener('storage', handleStorageChange);
  //   };
  // }, []);

  return (
    <>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {userRole == 'ADMIN' && (
            <Menu.Item>
              {({ active }) => (
                <Link
                  to="/setting"
                  className={classNames(
                    active ? 'bg-gray-100' : '',
                    'block px-4 py-2 text-sm text-gray-700',
                  )}
                >
                  Setting
                </Link>
              )}
            </Menu.Item>
          )}

          {navbarArray
            ?.filter((nav) => !nav.isNavbar)
            .map((item) => (
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to={item.href}
                    className={classNames(
                      active ? 'bg-gray-100' : '',
                      'block px-4 py-2 text-sm text-gray-700',
                    )}
                  >
                    {item.name}
                  </Link>
                )}
              </Menu.Item>
            ))}
          <Menu.Item>
            {({ active }) => (
              <div
                className={classNames(
                  active ? 'bg-gray-100' : '',
                  'block px-4 py-2 text-sm text-gray-700 cursor-pointer',
                )}
                onClick={() =>
                  setProfileState({ ...profileState, isModalVisible: true })
                }
              >
                Update Password
              </div>
            )}
          </Menu.Item>
          <hr />
          <Menu.Item>
            {({ active }) => (
              <span
                onClick={logoutAction}
                className={classNames(
                  active ? 'bg-gray-100' : '',
                  'block px-4 py-2 text-sm text-gray-700 cursor-pointer',
                )}
              >
                Sign out
              </span>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
      <UpdatePasswordModal state={profileState} setState={setProfileState} />
    </>
  );
};

const MobileNavbarDisclosure = ({ navbarArray, router }) => (
  <Disclosure.Panel className="xl:hidden">
    <div className="space-y-1 px-2 pt-2 pb-3">
      {navbarArray
        ?.filter((nav) => nav.isNavbar)
        .map((item) => (
          <Disclosure.Button
            key={item.name}
            as={NavLink}
            to={item.href}
            className={classNames(
              `${
                item.href === router.pathname
                  ? 'bg-indigo-400 text-white hover:text-white'
                  : 'text-gray-800 hover:text-white'
              } block px-3 py-2 rounded-md text-base font-medium hover:bg-indigo-400 `,
            )}
            aria-current={item.current ? 'page' : undefined}
          >
            {item.name}
          </Disclosure.Button>
        ))}
    </div>
  </Disclosure.Panel>
);

const ShowSoundAlarm = ({
  isModalVisible,
  setIsModalVisible,
  setAlarmSocket,
  alarmSocket,
  playAlarm,
  setPlayAlarm,
  setCloseAlarm,
}) => {
  const calendar = useCalendar();
  const header = [
    {
      title: 'Alarm Name',
      dataIndex: 'eventTitle',
      align: 'center',
      width: 150,
      render: (elm) => <div dir="auto">{elm}</div>,
    },
    {
      title: 'Description',
      dataIndex: 'eventDescriptionTemplate',
      align: 'center',
      width: 350,
      render: (text, record) =>
        record.eventDescriptionTemplate?.length >= 50 ? (
          <Popover
            content={<div dir="auto">{record.eventDescriptionTemplate}</div>}
            title={<div dir="auto">{record.eventTitle}</div>}
            overlayStyle={{ width: '500px' }}
          >
            <p dir="auto">
              {record.eventDescriptionTemplate.substring(0, 50)}...
            </p>
          </Popover>
        ) : (
          <p dir="auto">{record.eventDescriptionTemplate}</p>
        ),
    },
    {
      title: 'Date',
      dataIndex: 'occuredDate',
      align: 'center',
      render: (data) =>
        calendar
          ? moment(data)
              // Convert to Persian date format
              .locale('fa')
              .format('jYYYY/jMM/jDD (HH:mm:ss)')
          : moment(data)
              // Convert to Gregorian date format
              .format('YYYY/MM/DD (HH:mm:ss)'),

      width: 150,
    },
  ];

  useEffect(() => {
    let audio;
    let onUserGesture;
    let played = false;
    if (playAlarm && isModalVisible) {
      audio = new Audio('/audio/ErrormessageTune.mp3');
      audio.preload = 'auto';
      audio
        .play()
        .then(() => {
          played = true;
        })
        .catch(() => {
          onUserGesture = () => {
            if (!played) {
              audio.play().catch(() => {});
              played = true;
            }
            document.removeEventListener('pointerdown', onUserGesture);
            document.removeEventListener('keydown', onUserGesture);
          };
          document.addEventListener('pointerdown', onUserGesture);
          document.addEventListener('keydown', onUserGesture);
        });
    }

    return () => {
      if (onUserGesture) {
        document.removeEventListener('pointerdown', onUserGesture);
        document.removeEventListener('keydown', onUserGesture);
      }
      if (audio) {
        audio.pause();
        audio.currentTime = 0;
      }
    };
  }, [isModalVisible, playAlarm]);

  const handleCloseModal = async () => {
    setPlayAlarm(false);
    setIsModalVisible(false);
  };

  return (
    <SummaryModal
      show={isModalVisible}
      title={'Alarm'}
      closable={false}
      width={800}
      height={500}
    >
      <div className="overflow-x-auto overflow-y-auto w-[800px]">
        <div className="flex flex-col items-center p-5 mb-3 rounded-xl font-bold border border-red-500 text-xl  bg-red-white-blink">
          Attention!
        </div>
        <Table
          className="h-64 overflow-y-auto"
          size="small"
          dataSource={alarmSocket}
          // ?.filter((item) => item?.Category !== 'EVENT')
          columns={header}
          pagination={false}
          loading={!alarmSocket}
        />
        <div className="flex justify-center items-center">
          <Button
            onClick={handleCloseModal}
            className=" rounded-2xl flex justify-center items-center w-64 h-14 my-1 text-md text-white bg-[#6E6FF7]"
          >
            I understand
          </Button>
        </div>
      </div>
    </SummaryModal>
  );
};
